import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import vNFT from "../views/vNFT.vue";
import About from "../views/About.vue";
import Leaderboard from "../views/Leaderboard.vue";
import Leaderboard2 from "../views/Leaderboard2.vue";
import Branding from "../views/Branding.vue";
import Killerboard from "../views/Killerboard.vue";
import Airdrop from "../views/Airdrop.vue";
import Faqs from "../views/Faqs.vue";

import Race from "../views/Race.vue";
import ClaimTokens from "../views/ClaimTokens.vue";
import Farm from "../views/Farm.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/play",
    name: "Play",
    component: Home,
  },
  {
    path: "/",

    name: "About",
    component: About,
  },
  {
    path: "/faq",
    name: "Faqs",
    component: Faqs,
  },
  {
    path: "/leaderboard",
    name: "Leaderboard",
    component: Leaderboard2,
  },
  {
    path: "/farm",
    name: "Farm",
    component: Farm,
  },
  {
    path: "/leaderboard2",
    name: "Leaderboard2",
    component: Leaderboard,
  },
  {
    path: "/claim",
    name: "Claim Tokens",
    component: ClaimTokens,
  },
  {
    path: "/branding",
    name: "Branding",
    component: Branding,
  },
  // {
  //   path: "/killerboard",
  //   name: "Killerboard",
  //   component: Killerboard,
  // },
  // {
  //   path: "/race",
  //   name: "race",
  //   component: Race,
  // },
  {
    path: "/nft/:id",
    name: "vNFT",
    component: vNFT,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
